import React from 'react';
import { ENROLLMENT_BULK_ACTION_LIMIT } from 'src/pages/enrollments/constants';
import PropTypes from 'prop-types';

const BulkLimitMessage = ({ action }) => (
  <p className="mx-3 my-4">
    The maximum number of requests that can be {action} at a time is <strong>100</strong>.
    Please remove some requests to accept.
  </p>
);

const BulkErrorRowsMessage = ({ action }) => (
  <p className="mx-3 my-4">
    Some of the requests could not be {action}. Please review the requests to confirm that all required information
    is included.
  </p>
);

export function BulkAcceptDialogHeader({ selectedRowCount, erroredRows }) {
  if (selectedRowCount > ENROLLMENT_BULK_ACTION_LIMIT) {
    return (
      <BulkLimitMessage action="accepted" />
    );
  }

  if (erroredRows) {
    return (
      <BulkErrorRowsMessage action="accepted" />
    );
  }

  return (
    <p className="mx-3 my-4">
      You are about to mark these enrollment requests as <b>accepted</b>. Would you like to continue?
    </p>
  );
}

export function BulkAssignDialogHeader({ selectedRowCount, erroredRows }) {
  if (selectedRowCount > ENROLLMENT_BULK_ACTION_LIMIT) {
    return (
      <BulkLimitMessage action="assigned" />
    );
  }

  if (erroredRows) {
    return (
      <BulkErrorRowsMessage action="assigned" />
    );
  }

  return (
    <p className="mx-3 my-4">
      You are about to assign a user to the following requests. Would you like to continue?
    </p>
  );
}

BulkAssignDialogHeader.propTypes = {
  selectedRowCount: PropTypes.number.isRequired,
  erroredRows: PropTypes.bool.isRequired,
};

BulkAcceptDialogHeader.propTypes = {
  selectedRowCount: PropTypes.number.isRequired,
  erroredRows: PropTypes.bool.isRequired,
};

BulkErrorRowsMessage.propTypes = {
  action: PropTypes.string.isRequired,
};

BulkLimitMessage.propTypes = {
  action: PropTypes.string.isRequired,
};
